export { EditorForYouSpotlight } from '../src/components/spotlights/EditorForYouSpotlight.tsx';
